import { render, staticRenderFns } from "./PointHistory.vue?vue&type=template&id=97aa3826&scoped=true"
import script from "./PointHistory.vue?vue&type=script&lang=js"
export * from "./PointHistory.vue?vue&type=script&lang=js"
import style0 from "./PointHistory.vue?vue&type=style&index=0&id=97aa3826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97aa3826",
  null
  
)

export default component.exports